var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content warehouse-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_PrintRange"),
        width: "350px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { width: "100%" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-position": "left", "label-width": "80px" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("auto-number-input", {
                    staticStyle: { width: "80px" },
                    attrs: { no: "inputStart", precision: 0, max: 999, min: 1 },
                    model: {
                      value: _vm.from.inputStart,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "inputStart", $$v)
                      },
                      expression: "from.inputStart"
                    }
                  }),
                  _c("span", [_vm._v("-")]),
                  _c("auto-number-input", {
                    staticStyle: { width: "80px" },
                    attrs: { no: "inputEnd", precision: 0, max: 999, min: 1 },
                    model: {
                      value: _vm.from.inputEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "inputEnd", $$v)
                      },
                      expression: "from.inputEnd"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "padding-left": "5px",
                        "padding-right": "5px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrintNumber")))]
                  ),
                  _c("auto-number-input", {
                    staticStyle: { width: "80px" },
                    attrs: { no: "printNum", precision: 0, max: 999, min: 1 },
                    model: {
                      value: _vm.from.printNum,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "printNum", $$v)
                      },
                      expression: "from.printNum"
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("Pricing.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }